import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
const phrases = ['TU METABOLISMO NO ESTÁ ROTO — ESTÁ BLOQUEADO', 'ESBELTA® PARA DESHINCHARTE DESDE ADENTRO', 'FÓRMULA ANCESTRAL PARA MUJERES MADURAS', 'EQUILIBRIO HORMONAL NATURAL', 'ENVÍO GRATIS EN TODOS LOS PACKS'];
export function AnnouncementBar() {
  return <div className="bg-esbelta-violet text-white overflow-hidden py-2 flex items-center" data-id="element-1">
      <motion.div className="flex whitespace-nowrap" animate={{
      x: [0, -1000]
    }} transition={{
      repeat: Infinity,
      ease: 'linear',
      duration: 20
    }} data-id="element-2">
        {/* Render twice for seamless loop */}
        {[...Array(2)].map((_, i) => <div key={i} className="flex items-center" data-id="element-3">
            {phrases.map((phrase, index) => <Fragment key={index} data-id="element-4">
                <span className="text-xs font-semibold tracking-wider px-4" data-id="element-5">
                  {phrase}
                </span>
                <span className="text-white/50 px-2" data-id="element-6">•</span>
              </Fragment>)}
          </div>)}
      </motion.div>
    </div>;
}